export default "__VITE_ASSET__DZTfuzrl__"